// extracted by mini-css-extract-plugin
module.exports = {"GitHubMain":"GitHub_GitHubMain__tCl9t","GitHubSec":"GitHub_GitHubSec__3boMF","githubPicture":"GitHub_githubPicture__LCC6b"};